<template>
  <div class="box9">
    <div class="titleBox">
      <div class="title">
        全方位、精细化陪跑<br />
        带你打通财富和自由的任督二脉
      </div>
      <div class="subtitle">告别独自盲目摸索阶段，行业大牛带你狂飙！</div>
    </div>
    <div class="item" v-for="(item, index) in list" :key="index">
      <img
        :src="require(`../../../assets/coursePage/media/box9/${index + 1}.png`)"
        alt=""
      />
      <div class="title">{{ item.title }}</div>
      <div class="heng" :style="{ background: '#' + item.color }"></div>
      <p>{{ item.p }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          title: "直播一对一答疑",
          color: "61CBFA",
          p: "7-10年运营专业讲师，针对每一位学员账号问题直播一对一答疑，保证学员账号良性快速发展。",
        },
        {
          title: "连麦拔高性指导",
          color: "5670F7",
          p: "百万粉丝大V(短视频运营婧姐)直播间每周1次，每次2个小时直播连麦。",
        },
        {
          title: "180天全程督促",
          color: "AA42F6",
          p: "运营专业讲师全程跟进、提醒学员发布作品，指导学员产出优质作品。",
        },
        {
          title: "优秀案例及时分享",
          color: "E95CA4",
          p: "运营专业讲师时刻关注和挖掘行业优秀案例，整理优质账号（分析文档）发给学员学习。",
        },
        {
          title: "每月更新行业风口",
          color: "E94238",
          p: "每月更新行业新知识。",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.box9 {
  position: relative;
  width: 100%;
  padding: 80px 0 58px;
  background: url("../../../assets/coursePage/media/box9/bgc.png") no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  .titleBox {
    text-align: center;
    /* margin-top: -10px; */
    .title {
      font-size: 40px;
      font-family: PingFangSC-Semibold;
      font-weight: 500;
      color: #0d004d;
      line-height: 62px;
    }
    .subtitle {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #555266;
      line-height: 40px;
      margin-top: 10px;
      margin-bottom: 48px;
    }
  }
  .item {
    width: 690px;
    padding-bottom: 30px;
    background: #ede8ff;
    box-shadow: 0px 37px 59px 0px rgba(255, 255, 255, 0.35),
      0px 3px 7px 0px rgba(143, 121, 255, 0.35);
    border-radius: 26px;
    margin: 0 auto 30px;
    position: relative;
    padding-left: 154px;
    box-sizing: border-box;
    overflow: hidden;
    padding-right: 28px;
    img {
      width: 96px;
      height: 96px;
      position: absolute;
      left: 32px;
      top: 32px;
    }
    .title {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #0d004d;
      line-height: 36px;
      margin: 38px 0 22px;
    }
    .heng {
      width: 71px;
      height: 7px;
      border-radius: 4px;
    }
    p {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #343434;
      line-height: 40px;
      margin-top: 20px;
    }
  }
}
</style>
